import { useSelector } from "react-redux";
import { useGetBooksQuery } from "../../redux/features/api/apiSlice";
import Book from "./Book";

export default function Books() {
  const { data: books, isLoading, isError } = useGetBooksQuery();
  const { filter, search } = useSelector((state) => state.filter);

  let content = null;

  // isLoading=true state
  if (isLoading) {
    content = <div>Loading..</div>;
  }

  // isLoading=false & isError=true state
  if (!isLoading && isError) {
    content = <div>There was an error occurred. </div>;
  }

  // isLoading=false & isError=false & books count = 0 state
  if (!isLoading && !isError && books?.length === 0) {
    content = <div>No book found! </div>;
  }

  // isLoading=false & isError=false & books count > 0 state
  if (!isLoading && !isError && books?.length > 0) {
    // filter all featured
    if (filter === "featured") {
      content = books
        .filter((book) => book.featured)
        .map((book) => <Book key={book.id} book={book} />);
    }

    // search by keyword
    if (filter === "showAll" && search)
      content = books
        .filter((book) =>
          book.name.toLowerCase().includes(search.toLowerCase())
        )
        .map((book) => <Book key={book.id} book={book} />);

    // both filter && search
    if (filter === "featured" && search)
      content = books
        .filter((book) => book.featured)
        .filter((book) =>
          book.name.toLowerCase().includes(search.toLowerCase())
        )
        .map((book) => <Book key={book.id} book={book} />);

    // no filter && no search
    if (filter === "showAll" && !search) {
      content = books.map((book) => <Book key={book.id} book={book} />);
    }

    // nothing found
    if (content.length === 0)
      content = <p className="error"> Sorry. Nothing found!</p>;
  }

  return (
    <div className="space-y-6 md:space-y-0 md:grid grid-cols-1 lg:grid-cols-3 gap-6">
      {content}
    </div>
  );
}
